<template>
	<div class="newRulesDetails">
		<el-form label-width='100px' class="qcFrom editFroms contentBigBox" ref="newWorkTeamFrom" :rules="rules" :model="newWorkTeamFrom">
			<el-row>
				<el-form-item label="状态">
					<div class="exportTab marr20">
						<div class="sliderScreeningR">
							<a href="javascript:;" @click="seachTab(true)" :class="newWorkTeamFrom.Enable?'active':''">启用</a>
							<a href="javascript:;" @click="seachTab(false)" :class="!newWorkTeamFrom.Enable?'active':''">禁用</a>
						</div>
					</div>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="名称" prop="name">
					<el-input v-model="newWorkTeamFrom.name" size="small" style="width:500px;" placeholder="请输入名称"></el-input>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="类型" prop="type">
					<el-select size="small" v-model="newWorkTeamFrom.type" placeholder="请选择类型">
						<el-option v-for="item in detailsRulesParameter.types" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
					</el-select>
				</el-form-item>
			</el-row>
			<div class="dividingLine"></div>
			<el-row>
				<el-form-item label="筛选专家" prop="expert">
					<el-select size="small" v-model="userParameter.userFromType" placeholder="请选择类型">
						<el-option v-for="item in detailsRulesParameter.userFromType" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
					</el-select>
				</el-form-item>
			</el-row>
			<!-- <el-row>
                <el-form-item label="专家姓名" >
                    <el-input v-model="pages.name" placeholder="搜索专家姓名" style="width:200px; float: left;"></el-input>
                    <el-button type="warning"  @click="serch" style="margin:3px 0 0 30px; float: left;">搜索</el-button>
                    </el-form-item>
                </el-row>
                <el-row>
                 <el-form-item>
                 
                </el-form-item>
           </el-row> -->

			<el-row class="marl100">
				<el-col :span="14">
					<el-table class="qcTable" :data="getUserlist" ref="multipleTable" height="300" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="80"></el-table-column>
						<el-table-column prop="Name" label="姓名"></el-table-column>
						<el-table-column prop="LoginId" min-width="120" label="手机号"></el-table-column>
						<el-table-column prop="ExpertFromType" label="来源">
							<template slot-scope="scope">

								<span v-show="scope.row.ExpertFromType == 0">
                                未知
                            </span>
								<span v-show="scope.row.ExpertFromType == 1">
                                专委会
                            </span>
								<span v-show="scope.row.ExpertFromType == 2">
                                集团外
                            </span>
								<span v-show="scope.row.ExpertFromType == 3">
                                集团内
                            </span>
							</template>
						</el-table-column>
						<el-table-column prop="ExpertMajor" label="专业">
							<template slot-scope="scope">

								<span v-show="scope.row.ExpertMajor == 0">
                                未知
                            </span>
								<span v-show="scope.row.ExpertMajor == 1">
                                  超声 
                                  </span>
								<span v-show="scope.row.ExpertMajor == 2">
                                放射
                            </span>
								<span v-show="scope.row.ExpertMajor == 3">
                                核医学
                            </span>
							</template>
						</el-table-column>
						<el-table-column prop="Enable" label="状态">
							<template slot-scope="scope">
								<span v-show="scope.row.Enable == 1">
                                启用
                            </span>
								<span v-show="scope.row.Enable == 0">
                                禁用
                            </span>
							</template>
						</el-table-column>

					</el-table>
				</el-col>
				<el-col v-if='newWorkTeamFrom.Experts.length>0' :span="10">
					<div class="marl40">
						<label class="el-form-item__label" style="float: none;">已筛选专家</label>
						<div>
							<el-tag closable v-for="(item,index) in newWorkTeamFrom.Experts" @close="closeExperts(item)" :key='index' type="info">{{item.Name}}</el-tag>
						</div>
					</div>
				</el-col>
			</el-row>
			<!--<el-row class="table">
				
			</el-row>-->

			<el-row>
				<el-form-item>
					<el-button type="primary" class="mart40" @click="onSubmit">保存</el-button>
				</el-form-item>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		data() {
			return {

				rules: {
					type: [{
						required: true,
						message: '请选择类型',
						trigger: 'change'
					}],
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}]

				},

			}
		},
		computed: {
			...Vuex.mapState('managerUser', ['newWorkTeamFrom', 'detailsRulesParameter', 'pages', 'userParameter', 'getUserlist', 'NewWorkTeamFromExperts', 'loading'])
		},
		updated() {
			if(this.NewWorkTeamFromExperts.Experts) {
				this.$refs.multipleTable.clearSelection();
				this.NewWorkTeamFromExperts.Experts = false;
				if(this.newWorkTeamFrom.Experts.length > 0) {
					let UserGuid = this.getUserlist.filter(res => {
						for(let i = 0; i < this.newWorkTeamFrom.Experts.length; i++) {
							if(this.newWorkTeamFrom.Experts[i].UserGuid == res.UserGuid) {
								return res
							}
						}
					})
					UserGuid.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});

				}

			}
		},
		mounted() {
			this.$nextTick(function() {

			})
		},
		methods: {
			...Vuex.mapMutations('managerUser', ['setLoading']),
			...Vuex.mapActions('managerUser', ['expertsCreateorupdate', 'userlist']),
			seachTab(type) {
				this.newWorkTeamFrom.Enable = type;
			},
			closeExperts(item) {
				this.$refs.multipleTable.toggleRowSelection(item);
				let list = this.newWorkTeamFrom.Experts;
				for(let i = 0; i < list.length; i++) {
					if(list[i].UserGuid == item.UserGuid) {
						list.splice(i, 1); //删除下标为i的元素
					}
				}
			},
			onSubmit(formName) {
				this.$refs.newWorkTeamFrom.validate((valid) => {
					if(valid) {
						this.setLoading(true);
						this.expertsCreateorupdate()

					} else {
						return false;
					}
				});
			},
			// 搜索
			serch() {
				this.userlist();
			},
			//添加
			add() {},
			handleSelectionChange(row) {
				this.newWorkTeamFrom.Experts = row
			}
		}

	}
</script>